import React, { useState } from "react";
import { Card, CardBody, Button } from "reactstrap";

interface FilterCardProps {
  children: React.ReactNode;
  title?: string;
  defaultVisible?: boolean;
}

const FilterCard: React.FC<FilterCardProps> = ({ 
  children, 
  title = "Filtres",
  defaultVisible = true 
}) => {
  const [isVisible, setIsVisible] = useState(defaultVisible);

  return (
    <Card className="mb-4 card-ageroute rounded-3 shadow-sm border-0 overflow-hidden">
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="mb-0 fw-semibold d-flex align-items-center">
            <i className="ri-filter-3-line me-2 text-primary" />
            {title}
          </h6>
          <Button
            color="link"
            className="p-0 text-decoration-none"
            onClick={() => setIsVisible(!isVisible)}
            style={{ fontSize: "0.875rem" }}
          >
            {isVisible ? (
              <>
                <i className="ri-eye-off-line me-1"></i>
                Masquer les filtres
              </>
            ) : (
              <>
                <i className="ri-eye-line me-1"></i>
                Afficher les filtres
              </>
            )}
          </Button>
        </div>
        {isVisible && <div>{children}</div>}
      </CardBody>
    </Card>
  );
};

export default FilterCard;
